import { forwardRef, useImperativeHandle, useState } from 'react';
import { View } from 'react-native';
import Modal from 'react-native-modal';
import { Spinner } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';

import { textCategory } from '../../../Components/Reservation/constants';
import ResponsiveText from '../../../Components/ResponsiveText';
import { useLazyValidateQuery } from '../../../RTK/api/reservations';
import { ValidatePayload as ValidateApiPayload } from '../../../RTK/api/reservations/types';
import { Validate } from '../../../RTK/api/types';
import themeStyle from '../../../Theme/styles';

export type ValidatePayload = ValidateApiPayload;

const CheckAvailability = forwardRef<CheckAvailabilityRef>((_, ref) => {
  const [isVisible, setVisible] = useState(false);
  const [validate] = useLazyValidateQuery();

  useImperativeHandle(ref, () => ({
    show: _validate,
    hide() {
      setVisible(false);
    },
  }));

  const _validate = (payload, callback) => {
    setVisible(true);
    validate({ payload }).then((res) => {
      setVisible(false);
      const available = res?.data?.available;
      if (Array.isArray(available) ? !lodashIsEmpty(available) : available) {
        callback.onSuccess?.(payload, available);
      } else {
        callback.onError?.();
      }
    });
  };

  return (
    <Modal
      isVisible={isVisible}
      animationIn="fadeIn"
      animationOut="fadeOut"
      useNativeDriver
      statusBarTranslucent
    >
      <View style={themeStyle.flexDirectionRowCenterCenter}>
        <View
          style={[
            themeStyle.pageVerticalSpacing,
            themeStyle.pageHorizontalSpacing,
            themeStyle.pageBackground,
            themeStyle.alignItemsCenter,
            { borderRadius: 5 },
          ]}
        >
          <ResponsiveText
            category={textCategory.TITLE}
            style={themeStyle.spacingBottom}
          >
            Checking availability...
          </ResponsiveText>
          <Spinner size="large" status="info" />
        </View>
      </View>
    </Modal>
  );
});

type CallbackProps = {
  onSuccess: (data: ValidatePayload, response?: Validate) => void;
  onError: () => void;
};

export type CheckAvailabilityRef = {
  show: (data: ValidatePayload, callback: CallbackProps) => void;
  hide: () => void;
};

export default CheckAvailability;
